import React, { useState } from "react";
import { useObserver } from "mobx-react-lite";
import { Box, IconButton, TextField, Typography } from "@material-ui/core";
import { BaseModal } from "Components/Modal/BaseModal";
import { CancelButton } from "Globals/Styles/Control/Buttons";
import { Button } from "@material-ui/core";
import { Cell, Grid, useRouter } from "@shoothill/core";
import { Uploader } from "Components/Uploader/Uploader";
import SystemUpdateTwoToneIcon from "@material-ui/icons/SystemUpdateTwoTone";
import DeleteOutlinedIcon from "@material-ui/icons/DeleteOutlined";
import styled from "styled-components";
import { ReportModalStyle } from "Views/Project/Modals/Modal.Styles";
import { OtherProgrammeNotesViewModel } from "./OtherProgrammeNotesViewModel";
import { OtherProgrammeNotesFile } from "./OtherProgrammeNotesModel";

interface ICreatedModalProps {
    open?: boolean;
    onClose(): void;
    date: Date;
}

export const OtherProgrammeNotesView: React.FC<ICreatedModalProps> = (props) => {
    const { match } = useRouter();
    const { projectid } = match.params as any;
    const { open, onClose, date } = props;
    const [viewModel] = useState(() => new OtherProgrammeNotesViewModel(projectid, date));

    const COLUMNS8 = "1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr";

    const onSave = () => {
        let promise = viewModel.upsert();
        promise.then((response) => {
            if (response.wasSuccessful) {
                onClose();
            }
        });
    };

    return useObserver(() => (
        <BaseModal
            open={open}
            onClose={onClose}
            title={"Other programme notes"}
            PaperComponent={ReportModalStyle}
            actions={
                <>
                    <Button onClick={onSave} color="secondary" autoFocus variant="contained">
                        Add
                    </Button>
                    <CancelButton onClick={onClose}>Cancel</CancelButton>
                </>
            }
        >
            <Grid columnGap={30} rowGap={20} tc={COLUMNS8} dc={COLUMNS8} mb="35px">
                <Cell ts={8} ds={8}>
                    <NotesText>
                        <TextField
                            id="note-textarea"
                            multiline
                            minRows={5}
                            value={viewModel.getValue("otherProgrammeNote")}
                            onChange={(e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => viewModel.setValue("otherProgrammeNote", e.target.value)}
                            fullWidth
                            className="textarea-forminput"
                            label={"Note:"}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            placeholder={"Please add your note"}
                            disabled={false}
                            error={viewModel.getError("otherProgrammeNote") !== ""}
                            helperText={viewModel.getError("otherProgrammeNote")}
                            onBlur={() => viewModel.isFieldValid("otherProgrammeNote")}
                        />
                    </NotesText>
                </Cell>
                <Cell ts={8} ds={8}>
                    <FileUploader>
                        <Box gridTemplateColumns={"1fr 1fr"} display={"grid"} style={{ gap: "30px" }}>
                            <Box>
                                <Typography style={{ marginBottom: "8px", font: "normal normal 700 12px/16px Segoe UI", letterSpacing: "-0.18px", color: "#191919" }} variant="h5">
                                    Photo(s):
                                </Typography>
                                <Uploader handleSelectFile={(e: any) => viewModel.fileChange(e)} isFormDisabled={false} label="" />
                            </Box>
                            <Box>
                                {viewModel.model.otherProgrammePhotos.filter((el: any) => !el.isDeleted).length > 0 && (
                                    <Typography style={{ margin: "0 0px 8px" }} variant="h5">
                                        Photo(s) added
                                    </Typography>
                                )}
                                <Box className="uploadedFile">
                                    {viewModel.model.otherProgrammePhotos.map((item: OtherProgrammeNotesFile, index: number) => {
                                        return (
                                            !item.isDeleted && (
                                                <Box className="uploadedFile-box">
                                                    <Box className="uploadedFile-heading">
                                                        <IconButton onClick={() => viewModel.DownloadFile(item.photoURL, item.fileName)}>
                                                            <SystemUpdateTwoToneIcon />
                                                        </IconButton>
                                                        <h3>{item.fileName}</h3>
                                                    </Box>
                                                    <IconButton onClick={() => viewModel.deleteOtherProgrammePhotosFile(index)}>
                                                        <DeleteOutlinedIcon />
                                                    </IconButton>
                                                </Box>
                                            )
                                        );
                                    })}
                                </Box>
                            </Box>
                        </Box>
                    </FileUploader>
                </Cell>
            </Grid>
        </BaseModal>
    ));
};

const FileUploader = styled(Box)`
    min-height: 180px;
    .fileUpload {
        background: #6c93a626;
        border: 1px dashed #6c93a6;
        font: normal normal normal 12px/14px Open Sans;
        letter-spacing: 0px;
        color: #425b66;
        padding: 22px;
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 90px;
        margin: 0 !important;
    }
    .uploadedFile {
        grid-template-columns: 1fr;
        gap: 10px;
    }
`;

const NotesText = styled(Box)`
    label {
        margin-bottom: 8px !important;
        font: 700 12px / 16px "Segoe UI" !important;
        letter-spacing: -0.18px !important;
        color: rgb(25, 25, 25) !important;
        position: static;
    }
    .MuiInputBase-root {
        margin-top: 0 !important;
    }
`;
